import React, { Component } from 'react';
import { ErrorMessage, Field } from 'formik';
import { textFieldValidate } from './fieldValidateUtil';
import ReactSummernote from 'react-summernote-2';
import 'react-summernote-2/dist/react-summernote.css'; // import styles
import 'react-summernote-2/lang/summernote-es-EU';
import axios from 'axios';
import { builderSurfaceMultiPartHeader } from '../../../../common/utils/restApiHeaderUtils';
class TextArea extends Component {
  validate = (value) => {
    return textFieldValidate(value, this.props.field, this.props.isConstructorForm);
  };

  state = {
    textEditorValue: '',
  };

  onChange = (content) => {
    const { field, setFieldValue } = this.props;
    setFieldValue(field.fieldName, content);
  };

  uploadTextAreaOnServer = async (endPoint, data) => {
    const { version, projectId } = this.props;
    const header = builderSurfaceMultiPartHeader(projectId);
    const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/${endPoint}`;
    return await axios.post(url, data, header);
  };

  onImageUpload = async (fileList) => {
    const formData = new FormData();
    const { version, projectId, s3Url } = this.props;
    let endpoint = `v${version}/assets/${projectId}`;
    formData.append('file', fileList[0]);
    const { data } = await this.uploadTextAreaOnServer(endpoint, formData);
    let node = document.createElement('img');
    node.src = `${s3Url}${data.key}`;
    ReactSummernote.insertNode(node);
  };

  componentDidMount = () => {
    const { field, values } = this.props;
    if (field.fieldName && field.fieldName.includes('.')) {
      const fieldNames = field.fieldName.split('.');
      this.setState({ textEditorValue: values[fieldNames[0]][fieldNames[1]] });
    } else {
      this.setState({ textEditorValue: values[field.fieldName] });
    }
  };
  //TODO: Refactor
  render() {
    const { field } = this.props;
    return (
      <>
        <Field
          as={ReactSummernote}
          className="form-control h-auto no-bg-img"
          name={field.fieldName}
          value={this.state.textEditorValue}
          options={{
            lang: 'en-US',
            height: 200,
            dialogsInBody: true,
            placeholder: field.fieldTitle['en'],
            toolbar: [
              ['style', ['style']],
              ['font', ['bold', 'underline', 'clear']],
              ['fontname', ['fontname']],
              ['para', ['ul', 'ol', 'paragraph']],
              ['table', ['table']],
              ['insert', ['link', 'picture']],
              ['view', ['fullscreen', 'codeview']],
              ['color', ['color']],
            ],
          }}
          validate={this.validate}
          onChange={this.onChange}
          onImageUpload={this.onImageUpload}
        />

        <p className="errors" style={{ margin: '0', paddingLeft: '0' }}>
          <ErrorMessage name={field.fieldName} />
        </p>
      </>
    );
  }
}

export default TextArea;
